$(document).ready(function () {
  $("input.get-rates.global-button.continue-button").click(function () {
    $("div#wrapper-response").css("display", "block");
    if (!$("#address_zip").val()) {
      console.log(1);
    } else {
      setTimeout(function () {
        if ($("#wrapper-response").children().length > 0) {
          console.log(1);
        } else {
          $("div#wrapper-response").html(
            '<p class="loading_result">Please Wait .......</p>'
          );
          setTimeout(function () {
            $(".loading_result").remove();
          }, 6000);
        }
      }, 2500);
    }
  });

  // $('.icon-search').click(function() {
  //   $('.mobile-search .search-form__input').click();
  //   setTimeout(function () {
  //     $('.mobile-search .search-form__input').click();
  //   }, 1000);
  // });

  function getParameterByName(name, url) {
    if (!url) url = window.location.href;
    name = name.replace(/[\[\]]/g, "\\$&");
    var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
      results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return "";
    return decodeURIComponent(results[2].replace(/\+/g, " "));
  }
  // Check if "varient" parameter exists in the URL
  var varientValue = getParameterByName("variant");
  if (varientValue !== null) {
    // "varient" parameter exists, show alert
    console.log("not");
  } else {
    var product_name = $(".product_name").text();
    setTimeout(function () {
      if (product_name == "Quill") {
        $(
          ".swatch_options .swatch.clearfix.color input.v-swatch:nth-child(4)"
        ).trigger("click");
        setTimeout(function () {
          $(
            ".swatch_options .swatch.clearfix.color input.v-swatch:nth-child(2)"
          ).trigger("click");
        }, 1500);
      }
    }, 2000);
  }

  //   $('.article__title a').on('click', function() {
  //   sessionStorage.setItem('scrollPositioeen', $(window).scrollTop());
  // });

  // // Restore scroll position when returning to the page
  // var scrollPosition = sessionStorage.getItem('scrollPositioeen');
  // if (scrollPosition) {
  //   $(window).scrollTop(scrollPosition);
  //   // sessionStorage.removeItem('scrollPositioeen'); // Clear stored scroll position after restoring
  // }
});

$(document).ready(function () {
  $(window).on("scroll", function () {
    var scrollPosition = $(window).scrollTop();

    if (scrollPosition > 700) {
      $("body").addClass("fixed_header");
    } else {
      $("body").removeClass("fixed_header");
    }
  });

  // var offset = 100;
  // $("a").click(function () {
  //   const hrefClass = $(this).attr("class");
  //   var href_id = $(this).attr("href");
  //   console.log("href_id", href_id);
  //   $("html, body").animate({ scrollTop: $(href_id).offset().top - offset });
  // });
});
$(document).ready(function () {
  setTimeout(function () {
    if (
      !$(".product_links.cstm_test_product_links").parent().is(".seven.columns")
    ) {
      $(".seven.columns").append($(".product_links.cstm_test_product_links"));
    }
  }, 2500);
});
